import { createToastInterface } from 'vue-toastification';

const toast = createToastInterface({
  position: 'bottom-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
  toastClassName: 'painel-toast',
  bodyClassName: 'painel-toast__body',
  containerClassName: 'painel-toast-container'
});

export function showErrorToast(message) {
  toast.error(message || 'Ocorreu um erro inesperado. Tente novamente.');
}

export function showSuccessToast(message) {
  toast.success(message);
}

export function showInfoToast(message) {
  toast.info(message);
}
